import {postAction} from "@/eiuov-utils/axios/api";


const queryArticleListAction = (params) => postAction("/article/queryArticleList", params)
const queryArticleAction = (params) => postAction("/article/queryArticle", params)


export {
    queryArticleListAction,
    queryArticleAction,
}
